import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBanknote2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBanknote2"><Path fillRule="evenodd" clipRule="evenodd" d="M1.5 19.5V4.5H22.5V19.5H1.5ZM3.5 17.5H6C6 16.1193 4.88071 15 3.5 15V17.5ZM20.5 17.5V15C19.1193 15 18 16.1193 18 17.5H20.5ZM20.5 9C19.1193 9 18 7.88071 18 6.5H20.5V9ZM3.5 6.5H6C6 7.88071 4.88071 9 3.5 9V6.5ZM12 9.5C10.6193 9.5 9.5 10.6193 9.5 12C9.5 13.3807 10.6193 14.5 12 14.5C13.3807 14.5 14.5 13.3807 14.5 12C14.5 10.6193 13.3807 9.5 12 9.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBanknote2;
